import React from 'react';
import Slider from 'react-slick';
import { Image } from '@bytebrand/fe-ui-core-autobahn/compat';
import styles from './ImagesCompareModal.styl';
const maxWidth = 1100;
const getWidth = () => Math.min(window.innerWidth, maxWidth);
/* eslint-disable indent, @typescript-eslint/indent */
const ImageCompareModal = ({ imagesSources }) => {
    const [width, setWidth] = React.useState(getWidth());
    const onResize = React.useCallback(() => {
        setWidth(getWidth());
    }, []);
    React.useEffect(() => {
        window.addEventListener('resize', onResize);
        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);
    return (React.createElement("div", { className: styles.container, style: { width } },
        React.createElement(Slider, { speed: 0, swipe: false, adaptiveHeight: true }, imagesSources.map((src, index) => (React.createElement(Image, { key: index, width: '100%', ratioW: 1100, ratioH: 413, src: src, withLoader: true }))))));
};
export default React.memo(ImageCompareModal);
